module.exports = __webpack_public_path__ + "static/img/important7.bb200e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important7.png
// module id = a3kq
// module chunks = 1